import { eventually } from './unit/eventually';

export { eventually };
export default eventually;
